/**
 * Pre-compiled localized messages for DataTable component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import dataTableMessages_en from "./intl/en";
import dataTableMessages_de from "./intl/de";
import dataTableMessages_es from "./intl/es";
import dataTableMessages_fr from "./intl/fr-FR";
import dataTableMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const dataTableMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(dataTableMessages_en),
  de: normalizeMessages(dataTableMessages_de),
  es: normalizeMessages(dataTableMessages_es),
  "fr-FR": normalizeMessages(dataTableMessages_fr),
  "pt-BR": normalizeMessages(dataTableMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for DataTable component
 */
export type DataTableMessageKey =
  | "comfortable"
  | "comfortableAriaLabel"
  | "compact"
  | "compactAriaLabel"
  | "dataTable"
  | "dataTableBody"
  | "dataTableHeader"
  | "expandRows"
  | "fullText"
  | "fullTextAriaLabel"
  | "hiddenColumns"
  | "hiddenColumnsAriaLabel"
  | "hideColumn"
  | "layoutSettings"
  | "layoutSettingsAriaLabel"
  | "noHiddenColumns"
  | "pinRows"
  | "reset"
  | "resizeColumn"
  | "rowDensity"
  | "rowDensityAriaLabel"
  | "searchHiddenColumns"
  | "selectRow"
  | "settings"
  | "settingsTabsAriaLabel"
  | "textPreviews"
  | "textPreviewsAriaLabel"
  | "textVisibility"
  | "textVisibilityAriaLabel"
  | "visibleColumns"
  | "visibleColumnsAria"
  | "visibleColumnsList";
